import { BaseService } from "./BaseService";
import {
    Location,
    CreateLocationRequest,
    UpdateLocationRequest,
    LocationListRequest,
    LocationListResponse,
} from "@/models/Location";
import { LocationAddressDTO } from "@/models/Request";

class LocationServiceClass extends BaseService {
    protected get baseUrl(): string {
        return `${process.env.NEXT_PUBLIC_API_URL}/api/location`;
    }

    async getLocationList(
        filters: LocationListRequest
    ): Promise<LocationListResponse> {
        return this.postRetryable<LocationListResponse, LocationListRequest>(
            "list",
            filters,
            "json",
            2
        );
    }

    async getLocationById(id: number): Promise<Location> {
        return this.get<Location>(`${id}`);
    }

    async createLocation(data: CreateLocationRequest): Promise<Location> {
        return this.post<Location, CreateLocationRequest>("", data);
    }

    async updateLocation(
        id: number,
        data: UpdateLocationRequest
    ): Promise<Location> {
        return this.put<Location, UpdateLocationRequest>(`${id}`, data);
    }

    async deleteLocation(id: number): Promise<void> {
        // Soft delete (sets IsDeleted = true on backend)
        return this.delete<void>(`${id}`);
    }

    async getHemophiliaOriginLocation(): Promise<LocationAddressDTO> {
        const response =
            await this.get<LocationAddressDTO>("/hemophilia-origin");
        return response;
    }
}

export const locationService = new LocationServiceClass();
